import localization from "../statics/localization";

// CMS/MW wall-clock values use Europe/Istanbul, irrespective of browser timezone.
export const publicationDate = value => {
  if (typeof value !== "string" || !value.trim()) return null;
  const input = value.trim();
  const legacy = /^(\d{2})\.(\d{2})\.(\d{4}) (\d{2}):(\d{2})(?::(\d{2}))?$/.exec(input);
  const iso = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2})(?:\.\d+)?)?(Z|[+-]\d{2}:\d{2})?$/.exec(input);
  if (!legacy && !iso) return null;
  const parts = legacy ? [legacy[3], legacy[2], legacy[1], legacy[4], legacy[5], legacy[6] || "00"]
    : [iso[1], iso[2], iso[3], iso[4], iso[5], iso[6] || "00"];
  const [year, month, day, hour, minute, second] = parts.map(Number);
  const check = new Date(Date.UTC(year, month - 1, day, hour, minute, second));
  if (check.getUTCFullYear() !== year || check.getUTCMonth() !== month - 1 || check.getUTCDate() !== day ||
      check.getUTCHours() !== hour || check.getUTCMinutes() !== minute || check.getUTCSeconds() !== second) return null;
  const parsed = new Date(`${parts[0]}-${parts[1]}-${parts[2]}T${parts[3]}:${parts[4]}:${parts[5]}${iso?.[7] || "+03:00"}`);
  return Number.isFinite(parsed.getTime()) ? parsed : null;
};

export const publicationStart = item => item?.publicationDate ?? item?.LicenseStart ?? item?.Availability?.LicenseStart;

export const isComingSoon = (item, now = Date.now()) => {
  const starts = publicationDate(publicationStart(item));
  return item?.isComingSoon === true || item?.ShowAsComingSoon === true ||
    item?.Availability?.ShowAsComingSoon === true || !!(starts && starts.getTime() > now);
};

export const publicationLabel = item => {
  const date = publicationDate(publicationStart(item));
  if (!date) return localization.publicationDatePending;
  return `${localization.availableFrom} ${date.toLocaleString(localization.getLanguage() || "en", {
    timeZone: "Europe/Istanbul", year: "numeric", month: "long", day: "numeric", hour: "2-digit", minute: "2-digit"
  })}`;
};
